import { Button } from 'components/Button';
import styled from 'styled-components';

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const navWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

const navBtn = styled(Button)`
  width: fit-content;
`;
export { navWrapper, navBtn, MainContainer };
